import Button from 'common/Button';
import ButtonSecondary from 'common/ButtonSecondary';
import SubHeading from 'common/SubHeading';
import { styled } from 'styled-components';

import React from 'react';

const Div = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    flexgrow: 1;

    display: flex;
    flex-direction: column;
    padding: 40px 60px 10px 60px;

    @media (max-width: 960px) {
        padding-left: 32px;
        padding-right: 32px;
    }

    @media (max-width: 640px) {
        padding-left: 20px;
        padding-right: 20px;
    }

    .tableHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
    }
`;

const InnerPageLayout = ({ togglePopup, heading, btnText, children, buttonType = 'primary' }) => {
    const ButtonComponent = buttonType === 'secondary' ? ButtonSecondary : Button;
    
    return (
        <Div>
            <div className="tableHeader">
                <SubHeading>{heading}</SubHeading>
                <ButtonComponent onClick={togglePopup} className="btn">
                    {btnText}
                </ButtonComponent>
            </div>
            {children}
        </Div>
    );
};

export default InnerPageLayout;
